import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitBtn", "documentPanel"]

  connect() {
    this.updateSubmit()
  }

  updateSubmit() {
    const allChecked = this.checkboxTargets.every(cb => cb.checked)
    this.submitBtnTarget.disabled = !allChecked
  }

  toggleDocument(event) {
    event.preventDefault()
    const key = event.currentTarget.dataset.docKey
    const panel = document.getElementById(`doc-content-${key}`)
    if (panel) {
      panel.classList.toggle("hidden")
    }
  }
}
